import { Component, OnInit } from '@angular/core';
import { DelinquencyReportService } from 'src/app/services/delinquency-report/delinquency-report.service';
import { ColDef, ColGroupDef } from 'ag-grid-community';

@Component({
    selector: 'app-frt-delinquency-report',
    templateUrl: './frt-delinquency-report.component.html',
    styleUrls: ['./frt-delinquency-report.component.css'],
    standalone: false
})
export class FrtDelinquencyReportComponent implements OnInit {
  FRTDelinquencyReportVM$ = this.delinquentService.FRTDelinquencyReport$;
  FRTDelinquencyReportGridColumnDefs = [
    <ColDef>{
      colId: 'scac',
      headerName: 'SCAC',
      field: 'scac'
    },
    {
      colId: 'last4thQuarter',
      headerName: 'last4thQuarter',
      field: 'last4thQuarterStatus'
    },
    {
      colId: 'last3rdQuarter',
      headerName: 'last3rdQuarter',
      field: 'last3rdQuarterStatus'
    },
    {
      colId: 'last2ndQuarter',
      headerName: 'last2ndQuarter',
      field: 'last2ndQuarterStatus'
    },
    {
      colId: 'last1stQuarter',
      headerName: 'last1stQuarter',
      field: 'last1stQuarterStatus'
    }
  ];
  constructor(private delinquentService: DelinquencyReportService) {}

  ngOnInit() {}
}
